require('./bootstrap');
import Echo from "laravel-echo"
import VModal from 'vue-js-modal'
import Vue from 'vue'
import VueGtag from "vue-gtag";
import VueSession from 'vue-session'
import store from './store'
import VueCarousel from 'vue-carousel';
import * as VueGoogleMaps from "vue2-google-maps";
import VueLazyload from 'vue-lazyload'
import VueScrollTo from 'vue-scrollto'
import device from 'vue-device-detector-js'
import VueShortKey from 'vue-shortkey'
import Fragment from 'vue-fragment'
import VueClipboard from 'vue-clipboard2'
import VueQriously from 'vue-qriously'
import VueTimers from 'vue-timers'
import VueSlickCarousel from 'vue-slick-carousel'

window.Pusher = require('pusher-js');
require('./modules/vue-mask');

const currencyFormatter = require('currency-formatter');
const moment = require('moment');

Vue.prototype.$path = '/api';
Vue.use(VueClipboard)
Vue.use(Fragment.Plugin)
Vue.use(VueShortKey)
Vue.use(device)
Vue.use(VueSession);
Vue.use(VueCarousel);
Vue.use(VModal, {componentName: "v-modal"});
Vue.use(VueLazyload)
Vue.use(VueQriously)
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
});
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBx-7kg1w_8rBpai-9H-Dwq7kWEHRUtdlI",
  }
});

Vue.use(VueGtag, {
  config: {id: "UA-161600720-1"}
});
Vue.use(VueTimers)

Vue.prototype.$crConverter = function currencyFormat(value, code, format = '%s %v') {

  value = currencyFormatter.format(value, {
    code: code,
    locale: 'en-US',
    symbolOnLeft: true,
    thousand: ',',
    spaceBetweenAmountAndSymbol: true,
    precision: 2,
    format: format
  });

  if (value.indexOf(".00", value.length - 3) !== -1) {
    value = value.replace(new RegExp(".00$"), "");
  }

  return value;
};

Vue.prototype.$moment = moment;

Vue.component('App', require('./components/App.vue').default);
Vue.component('navbar-component', require('./components/NavbarComponent.vue').default);
Vue.component('cookies', require('./components/CookieComponent').default);
Vue.component('footer-component', require('./components/FooterComponent.vue').default);
Vue.component('subscribe-component', require('./components/SubscribeComponent.vue').default);


Vue.component('index-page-component', require('./components/IndexPageComponent.vue').default);
Vue.component('legal', require('./components/LegalComponent').default);
Vue.component('page', require('./components/PageComponent').default);
// Vue.component('product-component', require('./components/ProductMainComponent.vue').default);
Vue.component('customize-product', require('./components/CustomizeProductComponent.vue').default);
Vue.component('news-component', require('./components/NewsComponent.vue').default);
Vue.component('post-component', require('./components/PostComponent.vue').default);
Vue.component('supports-component', require('./components/SupportsComponent.vue').default);
Vue.component('support-entry-component', require('./components/SupportEntryComponents.vue').default);
Vue.component('support-component', require('./components/SupportComponent.vue').default);
Vue.component('contacts', require('./components/Contacts.vue').default);

Vue.component('login-component', require('./components/LoginComponent.vue').default);
Vue.component('register-component', require('./components/RegisterComponent.vue').default);
Vue.component('forgot-pwd-component', require('./components/ForgotPwdComponent.vue').default);
Vue.component('pass-reset-component', require('./components/PassResetComponent.vue').default);

Vue.component('profile', require('./components/MyAccount/ProfileComponent').default);

Vue.component('my-info-component', require('./components/MyAccount/MyInfoComponent.vue').default);
Vue.component('my-physical-info-component', require('./components/MyAccount/MyPhysicalInfoComponent.vue').default);

Vue.component('my-bikes-component', require('./components/MyAccount/MyBikesComponent.vue').default);
Vue.component('change-pwd-component', require('./components/MyAccount/ChangePwdComponent.vue').default);
Vue.component('my-orders-component', require('./components/MyAccount/MyOrdersComponents.vue').default);

Vue.component('cart', require('./components/CartComponent').default);
Vue.component('checkout', require('./components/CheckoutComponent').default);
Vue.component('manual-checkout', require('./components/ManualCheckoutComponent').default);

Vue.component('work-with-us', require('./components/WorkWithUsComponent').default);
Vue.component('vacancy', require('./components/VacancyComponent').default);
Vue.component('cv-form', require('./components/Parts/CVFormComponent').default);

Vue.component('page-not-found', require('./components/404').default);
Vue.component('media-library', require('./components/mediaLibrary').default);

Vue.component('thank-you', require('./components/ThankYou').default);
Vue.component('manuals', require('./components/Manuals').default);
Vue.component('store-redirect', require('./components/StoreRedirect').default);

Vue.component('choose-bike', require('./components/builds/Choose').default);
Vue.component('header-popup', require('./components/HeaderPopup').default);
Vue.component('zoom-gallery', require('./components/builds/parts/ZoomGallery').default);
Vue.component('main-modal', require('./components/MainModal').default);
Vue.component('basket', require('./components/basket/Basket').default);
Vue.component('compare', require('./components/builds/Compare').default);
Vue.component('checkout-login', require('./components/CheckoutLoginComponent').default);
Vue.component('loader-component', require('./components/LoaderComponent').default);
Vue.component('test-page-component', require('./components/TestPageComponent').default);
Vue.component('catalog-index', require('./components/catalog/IndexComponent.vue').default);
Vue.component('item-card-component', require('./components/ProductCard.vue').default);

Vue.component(VueSlickCarousel.name, VueSlickCarousel)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

const build = new Vue({
  store: store,
  el: '#app',
});

const metas = document.getElementsByTagName('meta');
let csrf = null;

for (let i = 0; i < metas.length; i++) {
  if (metas[i].getAttribute('name') === 'csrf-token') {
    csrf = metas[i].getAttribute('content');
  }
}

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  wsHost: window.location.hostname,
  wsPort: 6002,
  wssPort: 6002,
  disableStats: true,
  encrypted: true,
  headers: {
    'X-CSRF-TOKEN': csrf
  }
});
